module.exports = global.config = {
    api_server: "https://billing.uasinternationalmis.com/v2/",
    asset_server: "https://billing.uasinternationalmis.com",
    //api_server: "http://localhost/v2/",
    //asset_server: "http://localhost",
    docType: "Photo,Pan Card,Passport Front,Passport Back,Visa,Aadhar Card,Visa Photo,Other",
    clientType: "FIT,CORPORATE,GIP",
    status: "Active,In-Active",
    creditStatus: "Open,Expired,Redeemed",
    salutations: "Mr.,Mrs.,Master,Miss,Ms.,Mx.,Dr.",
    currencies: "INR,USD",
    years: "2022,2023,2024,2025,2026,2027,2028,2029,2030,2031,2032,2033,2034,2035,2036,2037,2038,2039,2040",
    months: [
        {name: "None", value: "0"},
        {name: "January", value: "1"},
        {name: "February", value: "2"},
        {name: "March", value: "3"},
        {name: "April", value: "4"},
        {name: "May", value: "5"},
        {name: "June", value: "6"},
        {name: "July", value: "7"},
        {name: "August", value: "8"},
        {name: "September", value: "9"},
        {name: "October", value: "10"},
        {name: "November", value: "11"},
        {name: "December", value: "12"}
    ],
    religions: "Hinduism,Islam,Christianity,Sikhism,Buddhism,Jainism,Atheism,Others",
    martialStatuses: "Married,Single,Divorced,Widow",
    items_per_page: 15,
    theme: [
        {name: "Blue", color: "0"},
        {name: "Green", color: "1"},
        {name: "Light Blue", color: "2"},
        {name: "Orange", color: "3"},
        {name: "Red", color: "4"},
        {name: "Grey", color: "5"},
        {name: "Dark", color: "6"}
    ],
    settings_token: "mail_cc,mail_bcc,mail_admin,sms_cc,sms_admin,greetings_mail_cc,greetings_sms_cc",
    variable_list_festival: "{client_name},{client_name_with_salutation}",
    variable_list: {
        mail_create_proforma: "{client_name},{client_name_with_salutation},{proforma_number},{amount},{currency_code},{currency_symbol}",
        mail_create_invoice: "{client_name},{client_name_with_salutation},{invoice_number},{amount},{currency_code},{currency_symbol}",
        mail_create_receipt: "{client_name},{client_name_with_salutation},{receipt_number},{amount},{currency_code},{currency_symbol}",
        mail_create_refund: "{client_name},{client_name_with_salutation},{refund_number},{amount},{transaction_id},{cancellation_charges},{currency_code},{currency_symbol}",
        mail_create_credit: "{client_name},{client_name_with_salutation},{credit_note_number},{amount},{valid_till},{currency_code},{currency_symbol}",
        mail_login_otp: "{otp},{user_info}",
        mail_permission: "{otp},{description},{employee_detail}",
        mail_birthday: "{client_name},{client_name_with_salutation}",
        mail_anniversary: "{client_name},{client_name_with_salutation}",
        mail_export: "{employee_detail},{export_detail},{ip}",
        sms_create_proforma: "{client_name},{client_name_with_salutation},{proforma_number},{amount},{currency_code},{currency_symbol}",
        sms_create_invoice: "{client_name},{client_name_with_salutation},{invoice_number},{amount},{currency_code},{currency_symbol}",
        sms_create_receipt: "{client_name},{client_name_with_salutation},{receipt_number},{amount},{currency_code},{currency_symbol}",
        sms_create_refund: "{client_name},{client_name_with_salutation},{refund_number},{amount},{transaction_id},{cancellation_charges},{currency_code},{currency_symbol}",
        sms_create_credit: "{client_name},{client_name_with_salutation},{credit_note_number},{amount},{valid_till},{currency_code},{currency_symbol}",
        sms_login_otp: "{otp},{user_info}",
        sms_permission: "{otp},{description},{employee_detail}",
        sms_birthday: "{client_name},{client_name_with_salutation}",
        sms_anniversary: "{client_name},{client_name_with_salutation}",
        sms_export: "{employee_detail},{export_detail},{ip}"
    }
};